"use strict";

import $ from "jquery";
import _ from "underscore";

export class BoardComponent {
  constructor(
    screenSize,
    $location,
    ProjectAPI,
    arrow,
    ProductAPI,
    LanguageService,
    $uibModal,
    Modal,
    gettextCatalog,
    Auth
  ) {
    "ngInject";
    var that = this;
    //Set same height for col-callout
    $(function () {
      $(".col-callout").matchHeight();
    });

    this.spinnerEnabled = true;
    this.Modal = Modal;
    this.ls = LanguageService;
    this.gettextCatalog = gettextCatalog;
    this.ProjectAPI = ProjectAPI;
    this.ProductAPI = ProductAPI;
    this.$location = $location;
    this.arrow = arrow;
    this.statusList = {
      11: this.gettextCatalog.getString("En cours de saisie"),
      12: this.gettextCatalog.getString("Envoyée"),
      13: this.gettextCatalog.getString("Demande soumise"),
      20: this.gettextCatalog.getString("En cours de traitement"),
      21: this.gettextCatalog.getString("Modification en cours"),
      22: this.gettextCatalog.getString("Modification envoyée"),
      23: this.gettextCatalog.getString("Demande soumise"),
      30: this.gettextCatalog.getString("Accordée"),
      31: this.gettextCatalog.getString("Accordée - Modification en cours"),
      32: this.gettextCatalog.getString("Accordée - Modification envoyée"),
      33: this.gettextCatalog.getString("Demande soumise"),
      40: this.gettextCatalog.getString("Refusée"),
      41: this.gettextCatalog.getString("Refusée - Modification en cours"),
      42: this.gettextCatalog.getString("Refusée - Modification envoyée"),
      43: this.gettextCatalog.getString("Demande soumise"),
      50: this.gettextCatalog.getString("Abandonnée"),
      60: this.gettextCatalog.getString("Abandonnée"),
      70: this.gettextCatalog.getString("Transférée à notre correspondant"),
      74: this.gettextCatalog.getString("Transférée à notre correspondant"),
      80: this.gettextCatalog.getString("Annulée (doublon)"),
      90: this.gettextCatalog.getString("Bloquée"),
    };

    this.fetch();

    this.confirmDelete = Modal.confirm.delete;

    this.isMobile = screenSize.on("xs", function (match) {
      that.isMobile = match;
    });
    this.activeUser = Auth.getCurrentUserSync();

    //-------Modal duplicate------------
    ProductAPI.getModels()
      .$promise.then(function (response) {
        that.products = JSON.parse(JSON.stringify(response));
        return;
      })
      .catch(() => {
        console.log("---> Error on load products type");
      }); // @@@ handle error by popup */

    this.openDuplicate = function (demand) {
      let data = null;
      var modalInstance = $uibModal.open({
        windowClass: "modal-primary",
        animation: true,
        ariaLabelledBy: "modal-title",
        ariaDescribedBy: "modal-body",
        component: "duplicate",
        size: "lg",
        resolve: {
          products() {
            return that.products;
          },
          demand() {
            return demand;
          },
        },
      });

      //Traiter le resultat venant du popup
      modalInstance.result.then(
        function (data) {
          data.isOriginalCopy = true;
          that.ProductAPI.save(data)
            .$promise.then((duplicata) => {
              duplicata = JSON.parse(JSON.stringify(duplicata));
              if (duplicata) {
                that.$location.path("/permission").search({
                  directive: "product",
                  project: duplicata.projectId,
                  demand: duplicata.id,
                });
                that.Modal.confirm.info(() => {})(
                  that.gettextCatalog.getString("Copie réussie"),
                  `${that.gettextCatalog.getString(
                    "Les auteurs et les œuvres ont bien été copiés dans la nouvelle demande"
                  )}.`,
                  that.gettextCatalog.getString("Fermer"),
                  "success"
                );
              }
              //that.fetch();
              return;
            })
            .catch((err) => {
              let textError = "";
              if (err.status === 403) {
                textError = that.gettextCatalog
                  .getString(`Certains auteurs sélectionnés ne sont
              pas gérés pour cette type d'utilisation`);
              } else {
                textError = that.gettextCatalog
                  .getString(`Des problèmes sont survenus lors de la copie.
              Veuillez recommencer, si le problème persiste vous pouvez nous contacter directement.`);
              }
              that.Modal.confirm.info(() => {})(
                that.gettextCatalog.getString("Erreur"),
                textError,
                "Fermer",
                "danger"
              );
              return;
            });
        },
        function () {}
      );
    };

    //------Modal share---------------
    this.openShare = function (project) {
      /*var parentSelector= 'body';
      var parentElem = parentSelector ?
        angular.element($document[0].querySelector(parentSelector)) : undefined;*/
      let data = null;
      var modalInstance = $uibModal.open({
        windowClass: "modal-primary",
        animation: true,
        ariaLabelledBy: "modal-title",
        ariaDescribedBy: "modal-body",
        component: "share",
        size: "lg",
        resolve: {
          users() {
            return project.user;
          },
          createdBy() {
            return project.createdBy;
          },
        },
      });

      //Traiter le resultat venant du popup
      modalInstance.result.then(
        function (result) {
          that.ProjectAPI.manageUser({
            op: result.op,
            id: project.id,
            email: result.email,
          })
            .$promise.then((_project) => {
              project.user = _project.user;
              if (result.op == "add") {
                that.Modal.confirm.info(() => {})(
                  that.gettextCatalog.getString("Partage réussi"),
                  `${that.gettextCatalog.getString(
                    "Votre projet a bien été partagé avec"
                  )} " ${result.email} ".`,
                  "Fermer",
                  "success"
                );
              } else if (result.op == "remove") {
                that.Modal.confirm.info(() => {})(
                  that.gettextCatalog.getString("Partage supprimé"),
                  `" ${result.email} " ${that.gettextCatalog.getString(
                    "n'a plus accès à ce projet."
                  )}`,
                  "Fermer",
                  "success"
                );

                if (result.email == that.activeUser.email) {
                  that.fetch();
                  return;
                }
              }
            })
            .catch((err) => {
              that.Modal.confirm.info(() => {})(
                that.gettextCatalog.getString("Erreur"),
                that.gettextCatalog
                  .getString(`Des problèmes sont survenus lors du partage.
          Veuillez vérifier l'adresse e-mail spécifié.
          Si le problème persiste vous pouvez nous contacter directement.`),
                "Fermer",
                "danger"
              );
            });
        },
        function () {}
      );
    };
  }

  fetch() {
    this.spinnerEnabled = true;
    this.ProjectAPI.query().$promise.then((projects) => {
      projects = JSON.parse(JSON.stringify(projects));
      for (var p in projects) {
        projects[p].isRemovable = true;
        for (var d in projects[p].demand) {
          let status = projects[p].demand[d].status;
          if ([11, 21, 31, 41].indexOf(status) != -1) {
            projects[p].demand[d]._status = 0; //saisie en cours
          } else if ([12, 22, 32, 42].indexOf(status) != -1) {
            projects[p].demand[d]._status = 1; //envoyée
          } else if (status == 20 || [13, 23, 33, 43].indexOf(status) != -1) {
            projects[p].demand[d]._status = 2; //en cours de traitement
          } else if (status == 30) {
            projects[p].demand[d]._status = 3;
          } else if (status == 40) {
            projects[p].demand[d]._status = 4;
          } else if (
            status == 50 ||
            status == 60 ||
            status == 70 ||
            status == 74 ||
            status == 80 ||
            status == 90
          ) {
            projects[p].demand[d]._status = 5;
          }
          projects[p].demand[d].input = _.sortBy(
            projects[p].demand[d].input,
            "useNumber"
          );
          projects[p].demand[d].listArtist = [];
          for (let u in projects[p].demand[d].input) {
            if (
              projects[p].demand[d].input[u].artist &&
              projects[p].demand[d].input[u].artist.label
            ) {
              projects[p].demand[d].listArtist.push(
                projects[p].demand[d].input[u].artist.label
              );
            }
          }
          projects[p].demand[d].listArtist =
            projects[p].demand[d].listArtist.join(", ");
          /*let maxCar = 50;
          if(projects[p].demand[d].listArtist.length>maxCar){
            projects[p].demand[d].subListArtist = projects[p].demand[d].listArtist.substring(0,maxCar)+' ...';
          }*/
          if ([11, 12].indexOf(projects[p].demand[d].status) == -1) {
            projects[p].isRemovable = false;
          }
        }
        //Sort demand in project by amended date
        projects[p].demand = _.sortBy(projects[p].demand, function (o) {
          return -new Date(o.dateAmended).getTime();
        });

        //Get last amended date of project
        projects[p].lastDateAmended = projects[p].dateCreated;
        if (projects[p].demand.length > 0) {
          projects[p].lastDateAmended = projects[p].demand[0].dateAmended;
        }
      }
      //Sort project by last amended date
      projects = _.sortBy(projects, function (p) {
        return -new Date(p.lastDateAmended).getTime();
      });

      this.projects = projects;
      this.spinnerEnabled = false;
    });
  }

  deleteProject(id, pKey) {
    let that = this;
    let title = this.gettextCatalog.getString("Confirmation");
    let text1 = this.gettextCatalog.getString("Supprimer le projet");
    text1 = `${text1} "${this.projects[pKey].name} "`;
    let text2 = this.gettextCatalog.getString(
      "et toutes les demandes d’autorisation qu’il contient"
    );
    let text = `${text1} ${text2} ?`;
    let confirmText = this.gettextCatalog.getString("Supprimer");
    let cancelText = this.gettextCatalog.getString("Annuler");
    this.confirmDelete((result) =>
      that.ProjectAPI.delete({
        id,
      })
        .$promise.then(() => {
          that.fetch();
          return;
        })
        .catch(() => {})
    )(title, text, confirmText, cancelText);
  }

  deleteDemand(id, project, key) {
    let that = this;
    let title = this.gettextCatalog.getString("Confirmation");
    let text = "";
    let confirmText = "";
    if (project.demand[key].status == 11 || project.demand[key].status == 12) {
      text = this.gettextCatalog.getString(
        "Supprimer la demande d’autorisation n°"
      );
      confirmText = this.gettextCatalog.getString("Supprimer");
    } else {
      text = this.gettextCatalog.getString(
        "Abandonner la demande d’autorisation n°"
      );
      confirmText = this.gettextCatalog.getString("Abandonner");
    }

    text = `${text} ${project.demand[key].id} ?`;
    let cancelText = this.gettextCatalog.getString("Annuler");
    this.confirmDelete((result) =>
      that.ProductAPI.delete({
        id,
      }).$promise.then((_demand) => {
        if (project.demand[key]) {
          if ([11, 12].indexOf(project.demand[key].status) != -1) {
            project.demand.splice(key, 1);
          } else if (
            [20, 21, 22, 30, 31, 32, 40, 41, 42].indexOf(
              project.demand[key].status
            ) != -1
          ) {
            project.demand[key].status = 50;
            project.demand[key]._status = 5;
          }
        }
      })
    )(title, text, confirmText, cancelText);
  }

  listProprety(_array, _prop) {
    var list = _array.map(function (item) {
      return item[_prop];
    });
    return list.join(", ");
  }

  createProject() {
    this.$location.path("/permission").search({
      project: null,
      directive: "introduction",
    });
  }

  openDemand(project, demand) {
    if (project) {
      this.$location.path("/permission").search({
        project: project.id,
        directive: "product",
        demand: demand ? demand.id : null,
      });
    }
  }

  openProject(project) {
    if (project) {
      this.$location.path("/permission").search({
        project: project.id,
        directive: "project",
      });
    }
  }
}

export default angular
  .module("dalApp.permission.board", [])
  .component("board", {
    template: require("./board.html"),
    controller: BoardComponent,
    controllerAs: "boardCtrl",
  }).name;



// WEBPACK FOOTER //
// ./client/app/permission/board/board.component.js